
(function () {
  if (window.aeSectionInit) return;

  var handlers = [];
  var hasFiredReady = false;

  function runAll(root) {
    handlers.forEach(function (fn) {
      try { fn(root || document); }
      catch (err) { console.error('[ae-section] handler error', err); }
    });
  }

  window.aeOnSectionReady = function (fn) {
    if (typeof fn !== 'function') return;
    handlers.push(fn);
    if (hasFiredReady) {
      try { fn(document); }
      catch (err) { console.error('[ae-section] handler error', err); }
    }
  };

  function onReady() {
    hasFiredReady = true;
    runAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    runAll(event.target);
    document.dispatchEvent(new CustomEvent('ae:section:loaded', {
      detail: { sectionId: event.detail && event.detail.sectionId, target: event.target }
    }));
  });

  window.aeSectionInit = true;
})();
